export default [
    //离职页面
    {
        path: '/leaveoffice/leaveoffice',
        name: '/leaveoffice/leaveoffice',
        component: () => import( '@/views/leaveoffice/leaveoffice.vue'),
        meta: {
            title: '离职交接',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //离职申请页面
    {
        path: '/leaveoffice/leaveApply',
        name: '/leaveoffice/leaveApply',
        component: () => import( '@/views/leaveoffice/leaveApply.vue'),
        meta: {
            title: '离职申请',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //离职审批页面
    {
        path: '/leaveoffice/leaveshenpi',
        name: '/leaveoffice/leaveshenpi',
        component: () => import( '@/views/leaveoffice/leaveshenpi.vue'),
    },
]
